import { render, staticRenderFns } from "./product-index.vue?vue&type=template&id=40865401&scoped=true"
import script from "./product-index.vue?vue&type=script&lang=js"
export * from "./product-index.vue?vue&type=script&lang=js"
import style0 from "./product-index.vue?vue&type=style&index=0&id=40865401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40865401",
  null
  
)

export default component.exports